/**
 * RESPONSIBILITY: draw the questions an event is asked often.
 *
 * <details> and not a scripted accordion: it opens without JavaScript, it is findable by
 * the browser's own page search when closed, and it is one element instead of a widget.
 */
import { Html } from '@framework/react';
import { idOf } from '@framework/core';
import { THEME } from '@app/sections';
import { Band } from './Band';
import type { BandProps } from './kind';

export function Questions({ s }: BandProps) {
  const qs = (s.questions ?? []).filter((q) => q.question);
  if (!qs.length) return null;

  return (
    <Band theme={THEME.Questions} heading={s.heading || 'Questions'}>
      <div className="ev-faq">
        {qs.map((q) => (
          <details key={idOf(q)}>
            <summary>{q.question}</summary>
            {q.answerHtml ? <Html className="md-body">{q.answerHtml}</Html> : null}
          </details>
        ))}
      </div>
    </Band>
  );
}
